
import { useTranslation } from "react-i18next";
import errorFilledOrange from "../../assets/images/errorFilledOrange.svg";
import errorFilledRed from "../../assets/images/errorFilledRed.svg";
import "./AlertBanner.scss";

export const AlertBanner = ({
    type,
    mainMessage,
    className,
}) => {
    return (
        <div className={`alert-banner-container ${className || ""}`}>
            <div className="left-section">
                <div className="alert-content">
                    <img
                        src={type === "error" ? errorFilledRed : errorFilledOrange}
                        alt="alert-warn"
                        title={type === "error" ? "Error" : "Warning"}
                        className="alert-warn"
                    />
                    <label className="alert-main">{mainMessage}</label>
                </div>
            </div>
        </div>
    );
};
